/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { BillOfQuantitiesPosition } from 'src/app/_model/bill-of-quantities-positions';
import { Resetable } from '../../resetter/resetable';

@Injectable()
export abstract class BillOfQuantitiesPositionsDaoService implements Resetable {
  public abstract saveBillOfQuantitiesPositions(
    billOfQuantitiesPositions: BillOfQuantitiesPosition[]
  ): Promise<void>;
  public abstract getBillOfQuantitiesPositions(): Promise<BillOfQuantitiesPosition[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
